export class QuestionModel
{
    Token: string;
    QuestionText: string;
}


// WEBPACK FOOTER //
// ./src/app/session/entities/QuestionModel.ts